module.exports = __webpack_public_path__ + "img/arrow-going-down-alt.ee91052b.svg";